import { useState, useEffect } from "react";
import { ReactComponent as SubMenuIcon } from "../../assets/icons/sideBarIcon.svg";
import sidemenucss from "../../css/sidemenu.module.css";
import { useHistory } from "react-router-dom";
import { GetFixedAsset } from "../../../WorkSpace/Components/ApiServices/apiHandler";

const FixedAssetSideBar = ({ activeTab, subMenuItem, fixedAssetID }) => {
  const [regName, setRegName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const redirectTo = (link) => {
    window.location.href = link;
  };

  const routerHistory = useHistory();
  const handleClick = (Link) => {
    routerHistory.push(Link);
  };

  const subMenu = () => {
    if (hideUnHideSubMenu === "A") {
      sethideUnHideSubMenu("I");
    } else {
      sethideUnHideSubMenu("A");
    }
  };

  const [hideUnHideSubMenu, sethideUnHideSubMenu] = useState("A");

  useEffect(() => {
    const fetchFixedAssetMeta = async () => {
      try {
        const response = await GetFixedAsset();
        const assetItems = response.data?.fixedAssets || response.data?.fixedAsset || response.data?.result || [];
        const assetArray = Array.isArray(assetItems) ? assetItems : [assetItems];
        const matchedAsset = assetArray.find(
          (item) =>
            item &&
            (item._id === fixedAssetID || item.id === fixedAssetID || item.fixedAssetID === fixedAssetID)
        );
        const selectedAsset = matchedAsset || assetArray[0];
        if (selectedAsset) {
          setRegName(selectedAsset.regname || selectedAsset.name || "Fixed Asset Register");
          setCompanyName(
            selectedAsset.companyData?.company_name ||
            selectedAsset.companyData?.companyName ||
            selectedAsset.company_name ||
            ""
          );
        }
      } catch (error) {
        console.error("Failed to load fixed asset sidebar metadata:", error);
      }
    };

    fetchFixedAssetMeta();
  }, [fixedAssetID]);

  const menuItems = [
    { key: 1, label: "Listing", pagelink: `/myfinV2/fixedAsset/listing` },
    {
      key: 2,
      label:"Movement Summary",
      pagelink: `/myfinV2/fixedAsset/summary`,
    },
    // {
    //   key: 3,
    //   label: "Lorem Ipsum",
    //   pagelink: `/myfinV2/fixedAsset/samplepage`,
    // },
    // { key: 4, label: "Lorem Ipsum", pagelink: `/myfinV2/fixedAsset/samplepage` },
  ];

  const activeItem = activeTab;
  const activeItemSubMenu = subMenuItem;

  return (
    <div
      className={`${sidemenucss.sidemenuContainer} ${sidemenucss.sidemenuBackgroundClr}`}
    >
      <div className={sidemenucss.sidemenuHeader}>
        <span className={sidemenucss.sidemenuTitlePS}>{regName || "Manufacturing Group"}</span>
        <div style={{ textAlign: 'left' }}>
           <p className={sidemenucss.companyText} >
            {companyName || "FIXED ASSETS"}
          </p>
        </div>
      </div>
      <div
        className={`${sidemenucss.sidemenuContent} ${sidemenucss.sidemenuLinksFontSize} ${sidemenucss.sidemenuContentTop}`}
      >
        <ul className={sidemenucss.sidemenuList}>
          {menuItems.map((item, index) => (
            <div key={index}>
              <li
                onClick={() => {
                  subMenu();
                  if (item.pagelink) {
                    setTimeout(() => handleClick(item.pagelink), 100);
                  }
                }}
                className={`${sidemenucss.sidemenuItem} ${
                  activeItem === item.label
                    ? sidemenucss.sidemenuItemActive
                    : ""
                }`}
              >
                <span className={sidemenucss.sidemenuItemname}>
                  <div className={sidemenucss.sideMenuItemContainer}>
                    {item.label}
                    <div className={sidemenucss.submenuIcon}>
                      {item.subMenu ? (
                        <SubMenuIcon
                          className={`${sidemenucss.submenuIconSvg} ${
                            hideUnHideSubMenu === "A"
                              ? null
                              : sidemenucss.rotatedIcon
                          }`}
                        />
                      ) : null}
                    </div>
                  </div>
                </span>
              </li>
              {item.subMenu ? (
                <div
                  className={`${sidemenucss.submenuContainer} ${
                    hideUnHideSubMenu === "A"
                      ? sidemenucss.sideMenuShow
                      : sidemenucss.sideMenuHide
                  }`}
                >
                  {item.subMenu.map((sub, idx) => (
                    <div
                      key={idx}
                      className={`${sidemenucss.submenuItem} ${
                        activeItemSubMenu === sub.label
                          ? sidemenucss.activeSubMenu
                          : null
                      }`}
                      onClick={() => handleClick(sub.link)}
                    >
                      {sub.label}
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FixedAssetSideBar;
